import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/staking.svg'
import _imports_1 from '@/assets/images/adaIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-30f4f99a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-transaction-card-outline" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-4"
}, null, -1))
const _hoisted_4 = { class: "text-cut" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-4"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_FullWrapContainer = _resolveComponent("FullWrapContainer")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_AmountText = _resolveComponent("AmountText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_LabeledItem = _resolveComponent("LabeledItem")!
  const _component_BlockCardLayoutBoxedItem = _resolveComponent("BlockCardLayoutBoxedItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BlockCardLayoutBoxedItem, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: 8,
          "wrapper-col": 24,
          justify: "space-between",
          wrap: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { md: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  wrap: false,
                  align: "middle",
                  class: "h-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: 0,
                      sm: 1
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_FullWrapContainer, {
                      title: _ctx.t('transaction hash'),
                      content: _ctx.blockTransactionDetails.transactionId
                    }, null, 8, ["title", "content"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              md: 4,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  wrap: false,
                  align: "middle",
                  class: "h-100"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createElementVNode("span", null, [
                      _createElementVNode("b", _hoisted_4, [
                        _createVNode(_component_LabeledItem, null, {
                          "inline-label": _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("transaction amount")), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_Tooltip, null, {
                              title: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("transaction amount")), 1)
                              ]),
                              default: _withCtx(() => [
                                (_ctx.blockTransactionDetails.transactionAmount)
                                  ? (_openBlock(), _createBlock(_component_AmountText, {
                                      key: 0,
                                      class: "text-cut",
                                      amount: _ctx.blockTransactionDetails.transactionAmount,
                                      minPrecision: 0,
                                      maxPrecision: 6
                                    }, null, 8, ["amount"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              md: 4,
              sm: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  wrap: false,
                  align: "middle",
                  class: "h-100"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createElementVNode("b", null, [
                      _createVNode(_component_LabeledItem, null, {
                        "inline-label": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("transaction fee")), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_Tooltip, null, {
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("transaction fee")), 1)
                            ]),
                            default: _withCtx(() => [
                              (_ctx.blockTransactionDetails.transactionFee)
                                ? (_openBlock(), _createBlock(_component_AmountText, {
                                    key: 0,
                                    class: "text-cut",
                                    amount: _ctx.blockTransactionDetails.transactionFee,
                                    minPrecision: 0,
                                    maxPrecision: 6
                                  }, null, 8, ["amount"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}